import { makeFieldSchema, FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const RepoAuthorizationFieldSchema = makeFieldSchema({
  output: z => z.string(),
  uiOptions: z =>
    z.object({
      objectLabel: z.string().describe('Label for the checkbox').optional(),
      requestUserCredentials: z
        .object({
          secretsKey: z
            .string()
            .describe(
              'Key used within the template secrets context to store the credential',
            ),
        })
        .describe(
          'Request user credentials to auth against the given SCM platform',
        ),
    }),
});

export type RepoAuthorizationUiOptions =
  typeof RepoAuthorizationFieldSchema.schema.uiOptions;

export type RepoAuthorizationProps = FieldExtensionComponentProps<boolean, RepoAuthorizationUiOptions>;

export const RepoAuthorizationSchema = RepoAuthorizationFieldSchema.schema;
